import Vue from 'vue';
import '@metaarchit/govmo-web-ui/lib/entry.less';
import GovmoWebUI from '@metaarchit/govmo-web-ui';

Vue.use(GovmoWebUI);
